// extracted by mini-css-extract-plugin
export var cardTest = "JobTransformationCard-module--cardTest--003da";
export var emptyJob = "JobTransformationCard-module--emptyJob--af23a";
export var userImage = "JobTransformationCard-module--userImage--b17dc";